import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import SEO from '@/components/feature/SEO';
import { faqs } from '@/mocks/articles';

export default function Home() {
  useEffect(() => {
    const existing = document.querySelector('script[data-schema="faq"]');
    if (existing) existing.remove();

    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-schema', 'faq');
    script.textContent = JSON.stringify(faqSchema);
    document.head.appendChild(script);

    return () => {
      const el = document.querySelector('script[data-schema="faq"]');
      if (el) el.remove();
    };
  }, []);

  return (
    <>
      <SEO
        title="自慰喷水完全指南 — 了解女性高潮潮喷原理 | 悦己新知"
        description="科学解析女性在自慰过程中发生喷水（潮喷）的生理原理、触发技巧与注意事项。帮助女性正确认识自身身体反应，消除误解，提升自我认知与性健康意识。"
        keywords="自慰喷水,女性潮喷原理,自慰技巧,潮喷是什么感觉,女性高潮类型,性健康科普,潮喷注意事项"
        canonicalUrl="/"
        pageType="WebSite"
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}